import React, { useEffect, useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { ReactComponent as DeleteIcon } from "./../../../assets/Icons/Delete.svg";
import { ReactComponent as EditIcon } from "./../../../assets/Icons/edit.svg";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import {
  ChangeUserRolePagePath,
  ChangeUserRolePagePathWithType,
} from "constants/pages";
import { DeleteUserFromFund } from "./delete-user-from-fund";
import { FundUsersRoles } from "types/FundUsersRoles";
interface RolesSettingsMenuProps {
  user: FundUsersRoles;
  refetch: () => void;
  nonSuperAdminAdminCount: number;
  superAdminEmail?: string;
  currentUserEmail?: string;
}
export const RolesSettingsMenu: React.FC<RolesSettingsMenuProps> = ({
  user,
  refetch,
  nonSuperAdminAdminCount,
  superAdminEmail,
  currentUserEmail,
}) => {
  const navigate = useNavigate();
  const [openCancelDialog, setOpenCancelDialog] = useState<boolean>(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDisabledClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    event.preventDefault();
  };
  const openEditPage = () => {
    const url = user.type
      ? ChangeUserRolePagePathWithType.replace(":id", String(user.id)).replace(
          ":type",
          user.type,
        )
      : ChangeUserRolePagePath.replace(":id", String(user.id));
    navigate(url);
  };

  // Super admin must never remove themselves. Non-super-admin admin can remove themselves only if at least one other non-super-admin admin remains.
  // Super admin can remove the last non-super-admin admin from the fund (as long as it's not themselves).
  const isSuperAdminRow = Boolean(superAdminEmail && user.email === superAdminEmail);
  const isCurrentUserSuperAdmin = Boolean(superAdminEmail && currentUserEmail === superAdminEmail);
  
  // If current user is super admin, they can see menu for any user except themselves
  // Otherwise, follow the existing logic: non-admin users always show menu, admin users only if at least 2 non-super-admin admins remain
  const shouldShowMenu = isCurrentUserSuperAdmin
    ? !isSuperAdminRow
    : !isSuperAdminRow && (user.role !== "ADMIN" || nonSuperAdminAdminCount >= 2);

  useEffect(() => {
    if (!shouldShowMenu) {
      setAnchorEl(null);
    }
  }, [shouldShowMenu]);

  return (
    <>
      <DeleteUserFromFund
        open={openCancelDialog}
        user={user}
        onClose={() => {
          setOpenCancelDialog(false);
          refetch();
        }}
      />
      <IconButton
        onClick={shouldShowMenu ? handleClick : handleDisabledClick}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <MoreVertIcon sx={{
          color: !shouldShowMenu ? 'neutral.light' : 'neutral.disabled',
        }} />
      </IconButton>
      {anchorEl && shouldShowMenu && (
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{
            "& .MuiMenu-paper": { px: 1 },
          }}
          MenuListProps={{
            onClick: (e) => e.stopPropagation(),
            onMouseDown: (e) => e.stopPropagation(),
          }}
        >
          <MenuItem className="contribution-dropdown" onClick={openEditPage}>
            <EditIcon /> Change role
          </MenuItem>
          <MenuItem
            className="contribution-dropdown"
            onClick={() => {
              setOpenCancelDialog(true);
              handleClose();
            }}
          >
            <DeleteIcon /> Delete
          </MenuItem>
        </Menu>
      )}
    </>
  );
};
